import { connect } from "react-redux";

import Component from "./User";

function mapDispatchToProps() {
  return {}
}

function mapStateToProps(state) {
  return {
    user: state.user,
    token: state.user.token,
    userType: state.userType,
    client: state.client
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)